import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["assetId", "period", "assetType"],
  _excluded2 = ["data"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQuery } from '@tanstack/react-query';
import i18n from 'i18n';
import api from 'utils/api';
import config from 'utils/config';
import isAdmin from 'utils/session/isAdmin';
import { formatPeriod } from 'actions/utils';
import { checkIsNumber } from 'types/utils';
import { assetQueryKeys } from '.';
export function fetchContentComments(_x, _x2) {
  return _fetchContentComments.apply(this, arguments);
}
function _fetchContentComments() {
  _fetchContentComments = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(contentId, period) {
    var isFolder,
      created_time,
      q,
      _yield$api,
      items,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          isFolder = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : false;
          created_time = formatPeriod(period);
          q = {
            fields: {
              commentCount: 'COUNT(DISTINCT id)'
            },
            filter: _objectSpread({
              created_time: created_time
            }, isFolder ? {
              // Folders contain just assets
              // Retrieve results from where the asset belongs to the folder
              asset: {
                parent_id: contentId
              }
            } : {
              content_id: contentId
            })
          };
          _context2.next = 1;
          return api('get', '/api/query/userComments', q);
        case 1:
          _yield$api = _context2.sent;
          items = _yield$api.items;
          return _context2.abrupt("return", items ? items[0].commentCount : 0);
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _fetchContentComments.apply(this, arguments);
}
function fetchAssetHistory(_x3, _x4) {
  return _fetchAssetHistory.apply(this, arguments);
}
function _fetchAssetHistory() {
  _fetchAssetHistory = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(assetId, period) {
    return _regeneratorRuntime.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", api('get', "/api/assets/".concat(assetId, "/stats/"), {
            duration: period
          }));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _fetchAssetHistory.apply(this, arguments);
}
function fetchAssetRating(_x5, _x6) {
  return _fetchAssetRating.apply(this, arguments);
}
function _fetchAssetRating() {
  _fetchAssetRating = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(assetId, period) {
    var isFolder,
      created_time,
      q,
      _yield$api2,
      items,
      _args4 = arguments;
    return _regeneratorRuntime.wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          isFolder = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : false;
          created_time = formatPeriod(period);
          q = {
            fields: {
              ratingCount: 'COUNT(rated_like)'
            },
            filter: _objectSpread({
              created_time: created_time
            }, isFolder ? {
              // Folders contain just assets
              // Retrieve results from where the asset belongs to the folder
              asset: {
                parent_id: assetId
              }
            } : {
              asset_id: assetId
            })
          };
          _context4.next = 1;
          return api('get', '/api/query/assetRatings', q);
        case 1:
          _yield$api2 = _context4.sent;
          items = _yield$api2.items;
          return _context4.abrupt("return", items ? items[0].ratingCount : 0);
        case 2:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _fetchAssetRating.apply(this, arguments);
}
export var useFetchAssetAnalytics = function useFetchAssetAnalytics(_ref) {
  var assetId = _ref.assetId,
    period = _ref.period,
    assetType = _ref.assetType,
    queryOptions = _objectWithoutProperties(_ref, _excluded);
  var isFolder = assetType === 'folder';
  function fetchAssetAnalytics() {
    return _fetchAssetAnalytics.apply(this, arguments);
  }
  function _fetchAssetAnalytics() {
    _fetchAssetAnalytics = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var promiseList, _yield$Promise$all, _yield$Promise$all2, assetHistory, assetRating, contentComments, ratingCount, commentsCount, history, totalFolderFavs, data;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            promiseList = [fetchAssetHistory(assetId, period), fetchAssetRating(assetId, period, isFolder)];
            if (config.enableComments) {
              promiseList.push(fetchContentComments(assetId, period, isFolder));
            }
            _context.next = 1;
            return Promise.all(promiseList);
          case 1:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
            assetHistory = _yield$Promise$all2[0];
            assetRating = _yield$Promise$all2[1];
            contentComments = _yield$Promise$all2[2];
            ratingCount = checkIsNumber(assetRating) ? assetRating : 0;
            commentsCount = checkIsNumber(contentComments) ? contentComments : 0;
            history = checkIsNumber(assetHistory) ? [] : assetHistory.history;
            totalFolderFavs = checkIsNumber(assetHistory) ? 0 : assetHistory.totalFolderFavs;
            data = [{
              title: i18n.t('stats_open', {
                count: history.reduce(function (a, b) {
                  return a + b;
                }, 0)
              }),
              value: history.reduce(function (a, b) {
                return a + b;
              }, 0)
            }, {
              title: i18n.t('stats_save', {
                count: totalFolderFavs
              }),
              value: totalFolderFavs
            }, {
              title: i18n.t('stats_like', {
                count: ratingCount
              }),
              value: ratingCount
            }];
            if (config.enableComments) {
              data.push({
                title: i18n.t('stats_comment', {
                  count: commentsCount
                }),
                value: commentsCount
              });
            }
            return _context.abrupt("return", {
              data: data,
              history: history
            });
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _fetchAssetAnalytics.apply(this, arguments);
  }
  var _useQuery = useQuery(_objectSpread(_objectSpread({
      queryKey: assetQueryKeys.assetAnalytics(assetId, period, assetType),
      queryFn: fetchAssetAnalytics,
      enabled: isAdmin()
    }, queryOptions), {}, {
      staleTime: 0,
      refetchOnMount: 'always'
    })),
    data = _useQuery.data,
    result = _objectWithoutProperties(_useQuery, _excluded2);
  return _objectSpread({
    data: data
  }, result);
};
export default useFetchAssetAnalytics;